import type { RemoteTrack } from 'livekit-client'

/**
 * Проверяет, находится ли элемент в видимой части вкладки.
 *
 * @param element - видеоплитка демонстрации
 */
function isVisibleVideo(element: HTMLVideoElement): boolean {
  const bounds = element.getBoundingClientRect()

  if (
    !element.isConnected ||
    bounds.width <= 0 ||
    bounds.height <= 0 ||
    bounds.right <= 0 ||
    bounds.bottom <= 0 ||
    bounds.left >= window.innerWidth ||
    bounds.top >= window.innerHeight
  ) {
    return false
  }

  // Скрытый родитель также останавливает adaptiveStream, даже если сам video видим.
  for (let current: HTMLElement | null = element; current; current = current.parentElement) {
    const style = window.getComputedStyle(current)

    if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) {
      return false
    }
  }

  return true
}

/**
 * Находит воспроизводимую видеоплитку, прикреплённую к нужной демонстрации.
 *
 * Отсутствие подходящей плитки означает неизвестное состояние, а не отказ.
 *
 * @param track - подписанный удалённый экран
 */
export function findVisibleScreenShareVideo(track: RemoteTrack): HTMLVideoElement | null {
  for (const element of track.attachedElements) {
    if (!(element instanceof HTMLVideoElement) || element.paused || element.ended) {
      continue
    }

    const stream = element.srcObject

    if (!(stream instanceof MediaStream) || !stream.getVideoTracks().some((item) => item === track.mediaStreamTrack)) {
      continue
    }

    if (isVisibleVideo(element)) {
      return element
    }
  }

  return null
}

/**
 * Проверяет наличие декодированного кадра в прикреплённом видеоплеере.
 *
 * Содержимое кадра не анализируется: чёрный кадр тоже может быть допустимым.
 *
 * @param video - видимая видеоплитка демонстрации
 */
export function hasCurrentScreenShareFrame(video: HTMLVideoElement): boolean {
  return video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA && video.videoWidth > 0 && video.videoHeight > 0
}
